/* ---------------------------------------------------------------------------
   BD MENU — navigazione a colonne progressive
   Bottega Dalmut, 7 settembre 2026

   Il drawer (apertura, chiusura, focus trap) resta quello di Prestige.
   Questo file gestisce solo cosa succede dentro: quale pannello e' visibile,
   le briciole di pane, quale set di tessere accompagna il livello corrente,
   e la riproduzione dei video (solo quando sono davvero a schermo).

   Non dipende da alcuna classe interna del tema: se Prestige cambia, il
   massimo che si perde e' l'aggancio per la larghezza del drawer.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  var ROOT = 'root';

  function BdMenu(el) {
    this.el = el;
    this.drawer = el.closest('header-sidebar');
    this.crumb = el.querySelector('[data-bd-back]');
    this.crumbTrail = el.querySelector('[data-bd-crumb-trail]');
    this.crumbCurrent = el.querySelector('[data-bd-crumb-current]');
    this.colSub = el.querySelector('.bd-menu__col--sub');
    this.colMedia = el.querySelector('.bd-menu__col--media');

    // Ogni voce del percorso: { id, title, level }
    this.path = [];

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    el.addEventListener('click', this.onClick);
    el.addEventListener('keydown', this.onKeydown);

    this.watchDrawer();
    this.render();
  }

  /* Quando il drawer si chiude il menu torna alla radice, cosi la prossima
     apertura riparte pulita invece di riprendere da dove si era rimasti. */
  BdMenu.prototype.watchDrawer = function () {
    var self = this;
    if (!this.drawer || typeof MutationObserver === 'undefined') return;

    this.observer = new MutationObserver(function () {
      if (!self.drawer.hasAttribute('open')) {
        self.path = [];
        self.render();
      } else {
        self.syncVideos();
      }
    });

    this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
  };

  BdMenu.prototype.onClick = function (event) {
    var back = event.target.closest('[data-bd-back]');
    if (back && this.el.contains(back)) {
      event.preventDefault();
      this.path.pop();
      this.render();
      return;
    }

    var pause = event.target.closest('[data-bd-pause]');
    if (pause && this.el.contains(pause)) {
      event.preventDefault();
      this.togglePause(pause);
      return;
    }

    var opener = event.target.closest('[data-bd-open]');
    if (!opener || !this.el.contains(opener)) return;

    event.preventDefault();

    var level = parseInt(opener.getAttribute('data-bd-level'), 10) || 1;

    // Riclicco la voce gia' aperta: la richiudo invece di riaprirla uguale.
    var current = this.path[level - 1];
    if (current && current.id === opener.getAttribute('data-bd-open')) {
      this.path = this.path.slice(0, level - 1);
      this.render();
      return;
    }

    this.path = this.path.slice(0, level - 1);
    this.path.push({
      id: opener.getAttribute('data-bd-open'),
      title: (opener.getAttribute('data-bd-title') || opener.textContent || '').trim(),
      level: level
    });

    this.render();
  };

  /* Escape risale di un livello finche' c'e' strada; alla radice lascia che
     sia il drawer a chiudersi da solo. */
  BdMenu.prototype.onKeydown = function (event) {
    if (event.key !== 'Escape' || this.path.length === 0) return;
    event.stopPropagation();
    this.path.pop();
    this.render();
  };

  BdMenu.prototype.render = function () {
    var depth = this.path.length;
    var navId = depth > 0 ? this.path[0].id : ROOT;
    var subId = depth > 1 ? this.path[1].id : null;

    this.el.setAttribute('data-depth', String(depth));
    if (this.drawer) this.drawer.setAttribute('data-depth', String(depth));

    // Colonna di sinistra: il livello corrente.
    this.show('[data-bd-nav-panel]', 'data-bd-nav-panel', navId);

    // Colonna centrale: esiste solo scendendo di un altro livello.
    this.show('[data-bd-sub-panel]', 'data-bd-sub-panel', subId);
    if (this.colSub) this.colSub.hidden = !subId;

    // Tessere: quelle del nodo piu' profondo che ne ha; altrimenti si risale.
    var tilesId = this.firstTiles([subId, navId, ROOT]);
    this.show('[data-bd-tiles]', 'data-bd-tiles', tilesId);
    if (this.colMedia) this.colMedia.hidden = !tilesId;

    // Quali colonne sono davvero in scena. Serve al CSS: una traccia della
    // griglia occupa spazio anche se la colonna dentro e' nascosta, e senza
    // questo il pannello si allargherebbe sul vuoto.
    var layout = subId ? (tilesId ? '3' : '2s') : (tilesId ? '2m' : '1');
    this.el.setAttribute('data-layout', layout);
    if (this.drawer) this.drawer.setAttribute('data-layout', layout);

    this.renderCrumb();
    this.markExpanded();
    this.syncVideos();
    this.resetScroll();
  };

  BdMenu.prototype.show = function (selector, attribute, activeId) {
    var nodes = this.el.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].hidden = nodes[i].getAttribute(attribute) !== activeId;
    }
  };

  BdMenu.prototype.firstTiles = function (candidates) {
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i]) continue;
      if (this.el.querySelector('[data-bd-tiles="' + cssEscape(candidates[i]) + '"]')) {
        return candidates[i];
      }
    }
    return null;
  };

  BdMenu.prototype.renderCrumb = function () {
    if (!this.crumb) return;

    if (this.path.length === 0) {
      this.crumb.hidden = true;
      return;
    }

    this.crumb.hidden = false;

    var last = this.path[this.path.length - 1];
    var trail = this.path.slice(0, -1).map(function (step) { return step.title; }).join(' / ');

    if (this.crumbTrail) {
      this.crumbTrail.textContent = trail ? trail + ' /' : '';
      this.crumbTrail.hidden = !trail;
    }
    if (this.crumbCurrent) this.crumbCurrent.textContent = last.title;
  };

  /* La voce da cui si e' scesi resta segnata nella colonna che la contiene. */
  BdMenu.prototype.markExpanded = function () {
    var self = this;
    var openers = this.el.querySelectorAll('[data-bd-open]');

    for (var i = 0; i < openers.length; i++) {
      var id = openers[i].getAttribute('data-bd-open');
      var isOpen = self.path.some(function (step) { return step.id === id; });
      openers[i].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  };

  /* Un video parte solo se il suo pannello e' davvero visibile: evita di
     tenere in riproduzione i set nascosti degli altri rami del menu.

     Su schermo piccolo resta fermo sul poster: il tema riceve una sola
     versione del file, pesante, e non vale una connessione mobile per una
     tessera. Chi lo vuole lo avvia con il pulsante. */
  BdMenu.prototype.syncVideos = function () {
    var videos = this.el.querySelectorAll('video[data-bd-video]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var small = window.matchMedia('(max-width: 999px)').matches;
    var isOpen = !this.drawer || this.drawer.hasAttribute('open');

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      var visible = isOpen && video.offsetParent !== null;
      var shouldPlay = visible && !reduced && !small && video.dataset.bdPaused !== 'true';

      if (shouldPlay) {
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }

      var button = video.parentNode.querySelector('[data-bd-pause]');
      if (button) button.setAttribute('aria-pressed', shouldPlay ? 'true' : 'false');
    }
  };

  BdMenu.prototype.togglePause = function (button) {
    var tile = button.closest('.bd-menu__tile');
    var video = tile && tile.querySelector('video[data-bd-video]');
    if (!video) return;

    if (video.paused) {
      video.dataset.bdPaused = 'false';
      var playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    } else {
      video.dataset.bdPaused = 'true';
      video.pause();
    }

    // pressed = il video sta andando. L'etichetta resta una sola, cosi non
    // serve una chiave di traduzione che il tema non ha in tutte le lingue.
    button.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
  };

  BdMenu.prototype.resetScroll = function () {
    var scrollers = this.el.querySelectorAll('.bd-menu__scroll, .bd-menu__tiles');
    for (var i = 0; i < scrollers.length; i++) scrollers[i].scrollTop = 0;
  };

  /* I nostri id sono generati da noi (bd-1-2), ma passano comunque da qui
     prima di finire in un selettore. */
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '');
  }

  function init(scope) {
    var menus = (scope || document).querySelectorAll('[data-bd-menu]');
    for (var i = 0; i < menus.length; i++) {
      if (!menus[i].bdMenu) menus[i].bdMenu = new BdMenu(menus[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Il theme editor ricarica la sezione header senza ricaricare la pagina.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
